<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<section id="main-container">
  <div id="main" class="col-xs-12">
    <app-breadcrumb
      currentPage="Minhas Fichas"
      routerCurrentPage="/ficha"
      voltar="hide"
    ></app-breadcrumb>

    <!--Consulta CEP Cliente Pesados Brasil-->
    <app-ficha-cep-cliente
      *ngIf="isOriginador"
      (cadastrarFichaEventEmitter)="addFicha()"
    ></app-ficha-cep-cliente>

    <!-- FICHAS -->
    <div id="records" class="row">
      <div class="col-xs-12">
        <div class="row header-fichas">
          <div class="col-xs-12">
            <h2 class="record-title">Minhas Fichas</h2>
          </div>
          <a
            class="new-record-novo"
            (click)="addFicha()"
            title="Adicionar nova ficha"
          >
            <i class="fa fa-plus"></i>
            <span>Adicionar ficha</span>
          </a>
        </div>

        <div class="produto-resultado">
          <app-select-produto
            (filtrarPorProduto)="onChangeFiltroProdutos($event)"
            [disabled]="
              isPesquisandoEmAnalise ||
              isPesquisandoAprovada ||
              isPesquisandoEmFechamento ||
              isPesquisandoisRecusada ||
              isPesquisandoisContratoCancelado
            "
            [isPanel]="false"
            #produtos
          ></app-select-produto>
          <div class="resultado-content">
            Resultados:
            <button
              class="btn btn-card-list"
              [ngClass]="{ active: isCardView }"
              (click)="onChangeView(true)"
            >
              Card
            </button>
            <button
              class="btn btn-card-list"
              [ngClass]="{ active: !isCardView }"
              (click)="onChangeView(false)"
            >
              Lista
            </button>
          </div>
        </div>

        <!-- Nav tabs -->
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" [ngClass]="{ active: isEmAnalise }">
            <a
              href="#analise"
              (click)="onClickEmAnalise()"
              aria-controls=""
              role="tab"
              data-toggle="tab"
            >
              Fichas em Análise
              <span *ngIf="isPesquisandoEmAnalise">
                <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </span>
              <app-notificacao-aba
                [quantidade]="quantSosPropostasEmAnalise"
              ></app-notificacao-aba>
            </a>
          </li>

          <li role="presentation" [ngClass]="{ active: isAprovada }">
            <a
              href="#aprovadas"
              (click)="onClickEmAprovada()"
              aria-controls=""
              role="tab"
              data-toggle="tab"
            >
              Fichas Aprovadas
              <span *ngIf="isPesquisandoAprovada">
                <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </span>
              <app-notificacao-aba
                [quantidade]="quantSosPropostasAprovadas"
              ></app-notificacao-aba>
            </a>
          </li>

          <li role="presentation" [ngClass]="{ active: isEmFechamento }">
            <a
              href="#fechamento"
              (click)="onClickEmFechamento()"
              aria-controls=""
              role="tab"
              data-toggle="tab"
            >
              Pagamentos
              <span *ngIf="isPesquisandoEmFechamento">
                <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </span>
              <app-notificacao-aba
                [quantidade]="quantSosPropostasEmFechamento"
              ></app-notificacao-aba>
            </a>
          </li>

          <li role="presentation" [ngClass]="{ active: isRecusada }">
            <a
              href="#recusadas"
              (click)="onClickEmRecusada()"
              aria-controls=""
              role="tab"
              data-toggle="tab"
            >
              Recusadas
              <span *ngIf="isPesquisandoEmFechamento">
                <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </span>
            </a>
          </li>

          <li
            role="presentation"
            [ngClass]="{ active: isContratoCancelado }"
            *ngIf="showContratoCancelado"
          >
            <a
              href="#canceladas"
              (click)="onClickEmContratoCancelado()"
              aria-controls=""
              role="tab"
              data-toggle="tab"
            >
              Contrato Cancelado
              <span *ngIf="isPesquisandoEmFechamento">
                <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </span>
            </a>
          </li>

          <li class="pull-right">
            <a
              (click)="isFilters = !isFilters"
              class="filters"
              title="Filtrar fichas de análise"
            >
              <i class="fa fa-search"></i> Filtrar Fichas
            </a>
          </li>
          <li class="pull-right">
            <a (click)="refreshFichas()" class="filters">
              <i class="fa fa-refresh"></i> Recarregar</a
            >
          </li>
        </ul>

        <div *ngIf="isFilters" class="row filter-panel">
          <form [formGroup]="filterForm">
            <div class="col-lg-3 col-md-6">
              <label for="status">Nome da loja</label>
              <select
                formControlName="nomeLoja"
                name="seller-store"
                class="form-control"
              >
                <option value="">Selecione...</option>
                <option
                  *ngFor="let lojista of listaLojistas"
                  [value]="lojista.id"
                >
                  {{ lojista.nome }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
              <label for="status">Nome cliente</label>
              <input
                type="text"
                class="form-control"
                name="nome"
                formControlName="nomeCliente"
              />
            </div>

            <div class="col-lg-2 col-md-6">
              <label for="status">CPF do cliente</label>
              <input
                type="text"
                class="form-control"
                name="nome"
                formControlName="cpfCliente"
                appOnlyDigitsLengthValidator
                appCpfCnpj
                [maxLength]="14"
              />
            </div>

            <div class="col-lg-2 col-md-3">
              <label for="operator">Número da ficha</label>
              <input
                type="text"
                class="form-control"
                name="numero"
                formControlName="numeroFicha"
              />
            </div>

            <div class="col-lg-2 col-md-3">
              <label for="operator">Status da Ficha</label>
              <select
                class="form-control"
                id="status"
                name="status"
                formControlName="statusFilter"
              >
                <option *ngFor="let item of status" value="{{ item.valor }}">
                  {{ item.descricao }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-3">
              <label for="datas">Dias</label>
              <select class="form-control" name="data" formControlName="data">
                <option value=""></option>
                <option value="5">Últimos 5 dias</option>
                <option value="10">Últimos 10 dias</option>
                <option value="15">Últimos 15 dias</option>
                <option value="20">Últimos 20 dias</option>
                <option value="25">Últimos 25 dias</option>
                <option value="30">Últimos 30 dias</option>
              </select>
            </div>

            <div class="col-lg-1 col-md-3 text-center">
              <label for="datas">Com SOS</label>
              <br />
              <input type="checkbox" name="sos" formControlName="sos" />
            </div>
          </form>
        </div>
        <!-- Tab panes -->
        <div class="tab-content" *ngIf="isCardView">
          <!-- FICHAS EM ANÁLISE -->
          <div
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isEmAnalise }"
            id="analise"
          >
            <app-ficha-status-home
              (quantidadeSos)="quantidadeSosAnalise($event)"
              [propostas]="propostasEmAnalise"
              [idFase]="1"
            >
            </app-ficha-status-home>
          </div>
          <!-- FICHAS APROVADAS -->
          <div
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isAprovada }"
            id="aprovadas"
          >
            <app-ficha-status-home
              (quantidadeSos)="quantidadeSosAnalise($event)"
              [propostas]="propostasAprovada"
              [idFase]="2"
            >
            </app-ficha-status-home>
          </div>
          <!-- FICHAS EM FECHAMENTO -->
          <div
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isEmFechamento }"
            id="fechamento"
          >
            <app-ficha-status-home
              (quantidadeSos)="quantidadeSosAnalise($event)"
              [propostas]="propostasEmFechamento"
              [idFase]="3"
            >
            </app-ficha-status-home>
          </div>
          <!-- FICHAS RECUSADAS -->
          <div
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isRecusada }"
            id="recusadas"
          >
            <app-ficha-status-home
              (quantidadeSos)="quantidadeSosAnalise($event)"
              [propostas]="propostasRecusada"
              [idFase]="4"
            >
            </app-ficha-status-home>
          </div>
          <!-- FICHAS CONTRATO CANCELADO -->
          <div
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isContratoCancelado }"
            id="canceladas"
            *ngIf="showContratoCancelado"
          >
            <app-ficha-status-home
              (quantidadeSos)="quantidadeSosAnalise($event)"
              [propostas]="propostasContratoCancelado"
              [idFase]="4"
            >
            </app-ficha-status-home>
          </div>
        </div>
        <div class="tab-content" *ngIf="!isCardView">
          <!-- FICHAS EM ANÁLISE -->
          <div
            *ngIf="propostasEmAnalise.length > 0"
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isEmAnalise }"
            id="analise"
          >
            <app-lista-ficha-home-status
              [propostas]="propostasEmAnalise"
              [idFase]="fichaCadastroHomeFaseIdEnum.ANALISE"
              *ngIf="isEmAnalise"
              (emitOrdenacao)="ordenar($event)"
            ></app-lista-ficha-home-status>
          </div>

          <div *ngIf="propostasEmAnalise.length === 0 && isEmAnalise">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS APROVADAS -->
          <div
            *ngIf="propostasAprovada.length > 0"
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isAprovada }"
            id="aprovadas"
          >
            <app-lista-ficha-home-status
              [propostas]="propostasAprovada"
              *ngIf="isAprovada"
              [idFase]="fichaCadastroHomeFaseIdEnum.APROVADAS"
              (emitOrdenacao)="ordenar($event)"
            ></app-lista-ficha-home-status>
          </div>

          <div *ngIf="propostasAprovada.length === 0 && isAprovada">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS EM FECHAMENTO -->
          <div
            *ngIf="propostasEmFechamento.length > 0"
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isEmFechamento }"
            id="fechamento"
          >
            <app-lista-ficha-home-status
              [propostas]="propostasEmFechamento"
              *ngIf="isEmFechamento"
              [idFase]="fichaCadastroHomeFaseIdEnum.PAGAMENTOS"
              (emitOrdenacao)="ordenar($event)"
            ></app-lista-ficha-home-status>
          </div>

          <div *ngIf="propostasEmFechamento.length === 0 && isEmFechamento">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS RECUSADAS -->
          <div
            *ngIf="propostasRecusada.length > 0"
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isRecusada }"
            id="recusadas"
          >
            <app-lista-ficha-home-status
              [propostas]="propostasRecusada"
              [idFase]="fichaCadastroHomeFaseIdEnum.RECUSADAS"
              *ngIf="isRecusada"
              (emitOrdenacao)="ordenar($event)"
            ></app-lista-ficha-home-status>
          </div>

          <div *ngIf="propostasRecusada.length === 0 && isRecusada">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS CONTRATO CANCELADO -->
          <div
            *ngIf="
              propostasContratoCancelado.length > 0 && showContratoCancelado
            "
            role="tabpanel"
            class="tab-pane fade"
            [ngClass]="{ 'in active': isContratoCancelado }"
            id="canceladas"
          >
            <app-ficha-status-home
              (quantidadeSos)="quantidadeSosAnalise($event)"
              [propostas]="propostasContratoCancelado"
              [idFase]="4"
            >
            </app-ficha-status-home>
          </div>

          <div
            *ngIf="
              propostasContratoCancelado.length === 0 && isContratoCancelado
            "
          >
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>
        </div>
      </div>
    </div>

    <div flex justify-content-start class="col-xs-12">
      <div class="col-lg-2 col-md-3">
        <label class="no-margin">Itens Por Página</label>
        <select
          class="form-control"
          [(ngModel)]="queryParams.size"
          (change)="onChangePageSize($event.target.value)"
        >
          <option *ngFor="let item of itensPaginaHome">
            {{ item }}
          </option>
        </select>
      </div>

      <pagination
        [totalItems]="queryParams[tabSelected]?.totalElements"
        [(ngModel)]="queryParams[tabSelected].page"
        (pageChanged)="pageChanged($event)"
        [maxSize]="5"
        [itemsPerPage]="queryParams.size"
        previousText="Anterior"
        nextText="Próxima"
        [disabled]="showLoader"
      ></pagination>
    </div>
  </div>
</section>

<a class="new-record" (click)="addFicha()" title="Adicionar nova ficha">
  <i class="fa fa-plus"></i>
  <span>Adicionar ficha</span>
</a>

<app-modal-message
  #modalMessage
  [title]="'Atenção!'"
  [hideClose]="true"
></app-modal-message>

<app-modal-container-generic #modalUpdateLojista>
  <app-update-shopkeeper-form (onClose)="onCloseUpdateShopkeeper()" [opened]="opened"></app-update-shopkeeper-form>
</app-modal-container-generic>

<script src="../../../assets/js/bootstrap-slider.min.js"></script>
